// Article share actions that need script: print and copy link.
// Facebook, X and e-mail are plain links.

export function initShare() {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-share]');
    if (!button) return;

    const action = button.dataset.share;
    if (action === 'print') {
      event.preventDefault();
      window.print();
    } else if (action === 'copy') {
      event.preventDefault();
      const url = button.getAttribute('href') || window.location.href;
      const done = () => {
        button.classList.add('is-copied');

        // A visible confirmation: `title` never shows on a touch device, and
        // role="status" makes a screen reader announce it too.
        button.parentElement?.querySelector('.hp-share__tip')?.remove();
        const tip = document.createElement('span');
        tip.className = 'hp-share__tip';
        tip.setAttribute('role', 'status');
        tip.textContent = 'link skopiowany';
        (button.parentElement || button).append(tip);

        setTimeout(() => {
          button.classList.remove('is-copied');
          tip.remove();
        }, 1600);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(done, () => window.prompt('Skopiuj link:', url));
      } else {
        window.prompt('Skopiuj link:', url);
      }
    } else if (action === 'more' && navigator.share) {
      event.preventDefault();
      navigator.share({ title: document.title, url: button.getAttribute('href') || window.location.href }).catch(() => {});
    }
  });
}
